const authProvider = {
    login: () => {
        // const request = new Request(process.env.REACT_APP_BASE_ENTRYPOINT + '/check_auth', {
        //     method: 'GET',
        //     headers: new Headers({
        //         'Content-Type': 'application/json',
        //         'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
        //         'X-Session': localStorage.getItem('session')
        //     }),
        // });
        // return fetch(request)
        //     .then(response => {
        //         if (response.status < 200 || response.status >= 300) {
        //             throw new Error(response.statusText);
        //         }
        //
        //         return response.json();
        //     })
        //     .then(data => {
        //         if (data.success) {
        //             //localStorage.setItem('token', process.env.REACT_APP_API_TOKEN);
        //             localStorage.setItem('permissions', data.roles);
        //             localStorage.setItem('authenticated', 'true');
        //         }
        //     });
    },
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('session');
        localStorage.removeItem('oldSession');
        localStorage.removeItem('permissions');
        if (localStorage.getItem('authenticated') === 'true') {
            localStorage.removeItem('authenticated');
            window.location = process.env.REACT_APP_BASE_ENTRYPOINT + '/auth/logout';
        }
        //return Promise.resolve();
    },
    checkError: error => {
    },
    checkAuth: () => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('token')) {
            const request = new Request(process.env.REACT_APP_BASE_ENTRYPOINT + '/check_auth', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                    'X-Session': localStorage.getItem('session')
                }),
            });

            const resp = fetch(request)
                .then(response => {
                    if (response.status < 200 || response.status >= 300) {
                        window.location = process.env.REACT_APP_BASE_ENTRYPOINT + '/auth/logout';
                    }

                    return response.json();
                })
                .then(data => {
                    localStorage.setItem('unprocessedExists', data.unprocessedExists);
                });
        }

        return localStorage.getItem('permissions') ? Promise.resolve() : Promise.reject();
    },
    getPermissions: () => {
        const role = localStorage.getItem('permissions');
        return role ? Promise.resolve(role) : Promise.reject();
    }
};

export default authProvider;